// extracted by mini-css-extract-plugin
export default {"UserListPage":"UserListPage_UserListPage__CqNPt"};